// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JWIrQ","content":"styles_content__1q6NM"};